// extracted by mini-css-extract-plugin
module.exports = {"targetModal":"targetModal_targetModal__3404d","header":"targetModal_header__1w0CU","modal":"targetModal_modal__27cRt"};